export enum SavingsType {
  SAVINGS_ACCOUNT = 'SavingsAccount',
  PREMIUM_BONDS = 'PremiumBonds',
  GIA = 'GIA',
  PERSONAL_PENSION_SIPP = 'PersonalPensionSIPP',
  WORKPLACE_PENSION = 'WorkplacePension',
  JUNIOR_PENSION = 'JuniorPension',
  CASH_ISA = 'CashISA',
  STOCKS_SHARES_ISA = 'StocksSharesISA',
  LIFETIME_ISA = 'LifetimeISA',
  HELP_TO_BUY_ISA = 'HelpToBuyISA'
}
